import { ListKits, AssayTypeItem } from '@src/types/graphql-types'
import { AssayType } from './enum'
import { some, isEmpty } from 'lodash'

export interface FinalSelection {
  productNo: string
  productName: string
  price?: string
  analytesInKit: string[]
  sampleType?: string
  customPremixing?: string
  spaceSaving?: string
  quantity: number
  currency?: string
  milliplexKitDataFromApi?: ListKits
}
interface KitProps {
  url: string
  data: FinalSelection
}
export interface SelectedKits {
  [id: string]: KitProps
}
export interface queryParamsType {
  activeLink?: string
  species?: string
  researchAreas?: string[]
  assay?: string
  plateType?: string
  analytes?: string[]
  selectedKits?: string
  instrumentType?: string[]
  previouslyViewed?: string
  anyInstrument?: string
}
export const getSelectedKitQueryString = (selectedKits: SelectedKits) => {
  return Object.values(selectedKits).length > 0
    ? JSON.stringify(Object.values(selectedKits).map((kit) => kit?.url))
    : ''
}

export const isPremixedProduct = (milliplexKit) =>
  milliplexKit?.assayType.includes(AssayType.Premixed)

export const isValidArray = (array: any) => {
  return !isEmpty(array) && some(array, Boolean)
}

export const checkAssayTypeDisabled = (
  assay: AssayTypeItem,
  species: string,
  researchAreas: string[]
) => {
  const assaysSpeciesResearchArea = assay.speciesResearchArea.find(
    (item) => item.species === species
  )
  if (assaysSpeciesResearchArea) {
    const checkForResearchArea =
      assaysSpeciesResearchArea.researchAreasList.find((single) => {
        return researchAreas.indexOf(single) !== -1
      })
    return (
      assay.plateType.length <= 0 ||
      (researchAreas.length === 0 &&
        !assaysSpeciesResearchArea.researchAreasList.includes('None')) ||
      (researchAreas.length > 0 && !checkForResearchArea)
    )
  } else {
    return true
  }
}

interface DefaultAssyFnProps {
  assayTypeList: AssayTypeItem[]
  species: string
  researchAreas: string[]
}

export const checkForDefaultAssay = ({
  assayTypeList,
  species,
  researchAreas,
}: DefaultAssyFnProps): string => {
  const assayEnabled = assayTypeList.filter((assay) => {
    return !checkAssayTypeDisabled(assay, species, researchAreas)
  })
  return assayEnabled.length > 1 ? '' : assayEnabled[0].assayType
}

export interface PlateTypeWithStatus {
  plateType: string
  enabled: boolean
}
